export default "__VITE_ASSET__Cpuv8bVu__"